export const CASE_MANAGER = 'caseManager';
export const DATES = 'dates';
export const DISCHARGE_REASON = 'reason';
export const END_DATE = 'endDate';
export const EPISODE_CLASSIFICATION = 'episodeClassification';
export const GROUP_ID = 'groupId';
export const HEALTH_PLAN_CLASSIFICATION = 'healthPlanClassification';
export const HOSPITAL = 'hospital';
export const HOSPITAL_CLIENT = 'hospitalClient';
export const LATEST_REHAB_STATE = 'latestRehabState';
export const LOCATION = 'location';
export const LOCATION_TYPE = 'locationType';
export const NONE = 'None';
export const NONE_OPTION = { id: 'null', name: NONE };
export const PAYER = 'payer';
export const PAYER_SOURCE = 'payer_source';
export const PLAN_TYPE_CLASSIFICATION = 'planTypeClassification';
export const PREDECESSOR_GROUP_TYPE = 'predecessorGroupType';
export const PREDECESSOR_LOCATION = 'predecessorLocation';
export const PHYSICIAN_GROUP = 'physicianGroup';
export const PHYSICIAN_TEAM = 'physicianTeam';
export const SENDING_GROUP_TYPE = 'sendingGroupType';
export const SENDING_LOCATION = 'sendingLocation';
export const START_DATE = 'startDate';
export const REFERRAL_SOURCE = 'referral_source';
export const REFERRED_BY_ID = 'referredById';
export const UTILIZATION_MANAGER = 'utilizationManager';
export const OWNER_CLIENT = 'ownerClient';
export const OWNER = 'owner';
export const ONLY_OTHER_ORGANIZATIONS = 'onlyOtherOrganizations';
export const STATUS_OUT_OF_DATE = 'statusOutOfDate';
export const REMOVED_FROM_CENSUS = 'removedFromCensus';

export enum PatientState {
  CURRENT = 'current',
  CONTINUED = 'continued',
  LATEST = 'latest',
}

export const filterKeysToWords: Record<string, string> = {
  [HEALTH_PLAN_CLASSIFICATION]: 'Plan',
  [PLAN_TYPE_CLASSIFICATION]: 'Plan Type',
  [EPISODE_CLASSIFICATION]: 'Episode Type',
  [CASE_MANAGER]: 'Case Manager',
  [HOSPITAL]: 'Hospital',
  [HOSPITAL_CLIENT]: 'Referral Source',
  [UTILIZATION_MANAGER]: 'Utilization Manager',
  // Inbound Referrals insights filters key off the snake_case insights Dimensions, which
  // humanize() (camelCase-only) can't format — so the "No … Assigned" chip would read
  // "No Referral_source Assigned". Map them to their filter labels (OLIO-2999).
  [REFERRAL_SOURCE]: 'Referral Source',
  // The Inbound Referrals list keys the same filter camelCase (its own store shape), where
  // humanize() would leave the chip reading "No Referral source Assigned".
  referralSource: 'Referral Source',
  [PAYER_SOURCE]: 'Payer',
};
